import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BatchCreate } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batch: BatchCreate;
  batchId: string;
}

export const useUpdateBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batch, batchId }: HookProps) => {
      const formData = new FormData();
      if (batch.file) {
        formData.append('file', batch.file);

        formData.append('name', batch.name);
        formData.append('customer', batch.customer);
        formData.append('template', batch.template);

        const result = await apiClient.batchesCore.updateBatch.mutation({ params: { id: batchId }, body: formData });
        if (result.status !== 200) throw result.body;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`New batch was uploaded, it's in the processing queue now!`);
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating the batch!');
    },
  });
};
